import { TransferTranslations } from "./transferTranslations.types";

const transferFrTranslations: TransferTranslations = {
    "transferPage": {
        "title": "Transfer",
        "noTransferTitle": "Je n'ai pas besoin de transfert",
        "noTransferDescription": "Continuer sans ajouter de transfert vers la station",
        "tneStationPopupTitle": "Besoin d'un transfert depuis la gare ?",
        "tneStationPopupDescription": "Nous proposons des transferts en bus partagé et en taxi privé vers certaines stations alpines.",
        "tneStationPopupNoTransfer": "Passer le transfert",
        "tneStationPopupWantTransfer": "Ajouter un transfert",
        "tneStationFilterLabel": "Votre station de ski",
        "tneStationCardTitle": "Réservez votre transfert jusqu'à votre station de ski.",
        "tneStationCardDescription": "Un moyen simple et pratique de rejoindre votre destination sans vous soucier des correspondances.",
    },
    transferFilters: {
        title: 'Préférences de transfert',
        options: {
            shortWaitingTime: 'Temps d\'attente court',
            doorToDoor: 'Porte à porte',
            privateGroup: 'Privé - uniquement pour votre groupe',
            carRental: 'Location de voiture',
        },
    },
    "bus": {
        title: 'Bus',
        estimatedTransferTime: 'Temps de transfert estimé :',
        note: 'Peut nécessiter des changements de bus en route ou une marche jusqu\'à votre hébergement.',
        description: 'Un shuttle partagé avec des horaires fixes et plusieurs escales. Des changements de bus ou des marches peuvent être nécessaires.'
    },
    "busLesArcs": {
        title: 'Bus',
        estimatedTransferTime: 'Temps de transfert estimé :',
        note: 'Peut nécessiter des changements de bus en route ou une marche jusqu\'à votre hébergement.',
        description: 'Un shuttle partagé avec des horaires fixes et plusieurs escales. Des changements de bus ou des marches peuvent être nécessaires.'
    },
    "taxi": {
        title: 'Taxi',
        estimatedTransferTime: 'Temps de transfert estimé :',
        note: 'Service porte à porte',
        description: 'Un taxi privé avec un chauffeur dédié pour votre usage exclusif.'
    },
    "funicular": {
        title: 'Funiculaire',
        estimatedTransferTime: 'Temps de transfert estimé :',
        note: 'Service porte à porte',
        description: 'Un funiculaire privé avec un chauffeur dédié pour votre usage exclusif.'
    }

}

export default transferFrTranslations;